/**
 * Format money by currency
 * Example: 670000 => 670.000 đ
 * @param money
 * @param locales
 * @param currency
 */
export const formatMoney = (money: string | number, locales = "vi-VN", currency = "VND") => {
  if (money === null || money === undefined) {
    return "";
  }
  if (typeof money === "string" && money.trim() === "") {
    return "";
  }
  let moneyNum: number;
  try {
    moneyNum = typeof money === "string" ? parseInt(money, 10) : Number(money);
  } catch {
    return "";
  }
  if (Number.isNaN(moneyNum)) {
    return "";
  }
  return new Intl.NumberFormat(locales, { style: "currency", currency: currency }).format(moneyNum);
};
